export const TEXT_FIELD_VARIANT = 'body16'
export const TABLE_STATUS = {
  active: 'ACTIVE',
  invited: 'INVITED',
  disabled: 'DISABLED',
}
